<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  data() {
    return {
      requestType: 'GET',
    };
  },
  mounted() {
    this.getConfigList('group_buying_customer_report_list');
  },
  methods: {
  },
};
</script>
